import React, { useState } from 'react';

interface ViewTechBrandingProps {
  className?: string;
  logoSize?: string;
  textSize?: string;
}

const ViewTechBranding: React.FC<ViewTechBrandingProps> = ({ 
  className = '', 
  logoSize = 'h-6',
  textSize = 'text-sm'
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
    console.warn('ViewTech logo could not be loaded');
  };

  return (
    <div className={`flex items-center justify-center space-x-2 text-gray-600 ${className}`}>
      <span className={textSize}>by</span>
      <a 
        href="https://vt-lb.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition-colors duration-200"
      >
        {!imageError && (
          <img 
            src="/storage/vtlogo.png" 
            alt="ViewTech Logo" 
            className={`${logoSize} w-auto opacity-80 hover:opacity-100 transition-opacity duration-200`}
            onError={handleImageError}
          />
        )}
        <span className="font-medium">ViewTech</span>
      </a>
    </div>
  );
};

export default ViewTechBranding;